import Marquee from "react-fast-marquee";

const defaultPhrases = [
  "Experience Doesn't Retire.",
  "You don't need another career.",
  "Maybe you've got One More Shift.",
];

export const EditorialMarquee = ({ phrases = defaultPhrases }) => (
  <div className="bg-primary py-10 md:py-14 overflow-hidden border-y border-white/10" data-testid="editorial-marquee">
    <Marquee speed={30} gradient={false} aria-hidden="true">
      {[...phrases, ...phrases].map((p, i) => (
        <span key={i} className="flex items-center">
          <span className="font-serif italic text-4xl md:text-6xl text-background whitespace-nowrap px-8 md:px-12">
            {p}
          </span>
          <img src="/brand/mark.svg" alt="" className="h-8 w-8 md:h-12 md:w-12 opacity-90 shrink-0" />
        </span>
      ))}
    </Marquee>
  </div>
);
